import { Directive, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Directive()
 
export abstract class ComponentBase implements OnDestroy {
  destroy$ = new ReplaySubject<void>(1);

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
